export const LogoMark = ({ className = "h-11 w-11" }) => (
  <img src="/images/logo-sm.png" alt="Clean As Fuck Cleaning Co. logo" className={`${className} shrink-0 rounded-full object-contain`} data-testid="brand-logo" />
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark />
    {!compact && (
      <span className="flex flex-col leading-none">
        <span className="font-display text-lg uppercase tracking-wide text-zinc-100">Clean as fuck</span>
        <span className="font-serif-i text-sm text-zinc-400">Cleaning Co. LLC</span>
      </span>
    )}
  </span>
);
